package com.xtream.data_kmp.dto


import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.KSerializer
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Serializer
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonDecoder
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.jsonPrimitive

@Serializable(with = XtreamActivationSerializer::class)
abstract class XtreamActivationBaseUserInfo: BaseAccount() {
    @SerialName("user_info")
    override val userInfo: UserInfo?=null
    @SerialName("server_info")
    override val serverInfo: ServerInfo?=null

    fun toXtreamUser(): Account?{
        if (userInfo==null || serverInfo==null)
            return  null

        return Account(
            userInfo = userInfo!!,
            serverInfo = serverInfo!!)
    }
}

@Serializable

data class XtreamActivationUserInfo(
    @SerialName("user_info")
    override val userInfo: UserInfo?=null,
    @SerialName("server_info")
    override val serverInfo: ServerInfo?=null,
    override val isLoggedIn: Boolean?=false
): XtreamActivationBaseUserInfo()

@OptIn(ExperimentalSerializationApi::class)
@Serializer(forClass =  XtreamActivationBaseUserInfo::class)
object XtreamActivationSerializer : KSerializer<XtreamActivationBaseUserInfo> {
    override fun deserialize(decoder: Decoder): XtreamActivationBaseUserInfo {
        val json = (decoder as JsonDecoder).decodeJsonElement()

        return parseInfo(json)
    }

    private fun parseInfo(json: Any?): XtreamActivationBaseUserInfo {


        return when (json) {
            is JsonArray -> XtreamActivationUserInfo()
            is JsonObject -> {
                //  Info()
                val js = Json {
                    ignoreUnknownKeys = true
                    explicitNulls = false


                }
                val newJson = """{
                                  "user_info":{
                                     "username":${json["username"]},
                                     "password":${json["password"]},
                                     "message":${json["message"]},
                                     "status":"${json["status"]?.jsonPrimitive?.content}",
                                     "exp_date":"${json["expire"]?.jsonPrimitive?.content}",
                                     "is_trial":"${json["is_trial"]?.jsonPrimitive?.content}",
                                     "active_cons":${json["active_connections"]},
                                     "created_at":"${json["created_on"]?.jsonPrimitive?.content}",
                                     "max_connections":"${json["max_connections"]?.jsonPrimitive?.content}",
                                     "allowed_output_formats":${json["allowed_output_formats"]},
                                     
                                     "token":"${json["max_connections"]?.jsonPrimitive?.content}",
                                     "user_agent":"${json["user_agent"]?.jsonPrimitive?.content}"
                                  },
                                  "server_info":${(json["server_info"] as? JsonObject?)}
                             }"""

              val transformedUser=  js.decodeFromString<XtreamActivationUserInfo>(newJson)
           println("+++:${transformedUser.serverInfo}")
                transformedUser
            }

            else -> XtreamActivationUserInfo()
        }
        /* return try {
            Json.decodeFromString<Info>(info.toString())
         } catch (e: Exception) {
             //(info as JsonArray).map { Json.decodeFromString<Name>(it.toString()) }
             Info()
         }*/
    }
}